import "./Utils.css";

export const formatFechaHora = (value) => {
    const date = new Date(value);
    return date.toLocaleString("es-AR", {
        weekday: "short",
        day: "numeric",
        month: "short",
        hour: "2-digit",
        minute: "2-digit",
    });
};

export const esProximo = (turno) =>
    new Date(turno.fechaHora) > new Date() && turno.estado !== "cancelado" && turno.estado !== "realizado";

const ESTADO_CONFIG = {
    disponible: { label: "Disponible", className: "disponible" },
    reservado: { label: "Reservado", className: "confirmado" },
    confirmado: { label: "Confirmado", className: "confirmado" },
    pendiente_confirmacion: { label: "Pendiente de confirmación", className: "disponible" },
    realizado: { label: "Realizado", className: "realizado" },
    cancelado: { label: "Cancelado", className: "cancelado" },
};

export const BadgeEstado = ({ estado }) => {
    const config = ESTADO_CONFIG[estado] || { label: estado, className: "disponible" };
    return <span className={`badge badge--${config.className}`}>{config.label}</span>;
};
